import { faChevronDown, faChevronUp, IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import styled from "styled-components";

const Title = styled.div`
    position: relative;
    padding: 0 3em 0 1em;
`;

const Container = styled.div`
    overflow: hidden;
    position: relative;
    display: inline-block;
    background: #0001;
    border-radius: 1em;
    padding: 0.8em 0;
    border: 1px solid #0000;
    cursor: pointer;
    max-width: 100%;

    transition: 100ms;
    &:hover {
        transition: 100ms;
        border: 1px solid #666;
    }
`;

const InnerContainer = styled.div`
    /* overflow: hidden; */
    max-height: 100vh;
    transition: 200ms;
    padding: 0 1em;
    &.limit {
        max-height: 0;
        transition: 200ms;
        opacity: 0;
    }
`;

const Collapser = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 20px;
    top: 0px;
    font-size: 1.7em;
    transition: 100ms;
`;

const Icon = styled(FontAwesomeIcon)`
    transform: scale(1.3);
    margin: 0.2em 0.3em 0 0;
    opacity: 0.5;
`;

type CollapseContainerProps = {
    title: string;
    children: React.ReactNode;
    collapsed?: boolean;
    icon?: IconDefinition;
    className?: string;
    style?: React.CSSProperties;
};

export function CollapseContainer(props: CollapseContainerProps) {
    const [collapsed, setCollapsed] = useState(props.collapsed ?? true);
    return (
        <Container className={props.className} style={props.style} onClick={() => setCollapsed(!collapsed)}>
            <Title>
                <h3>
                    {props.icon && <Icon icon={props.icon} />} {props.title}
                </h3>
                <Collapser>
                    <FontAwesomeIcon icon={collapsed ? faChevronDown : faChevronUp} />
                </Collapser>
            </Title>
            <InnerContainer className={collapsed ? "limit" : ""}>{props.children}</InnerContainer>
        </Container>
    );
}
